var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 8.625C0.998047 13.0006 4.55998 16.5625 8.93555 16.5625C13.3111 16.5625 16.873 13.0006 16.873 8.625C16.873 4.24943 13.3111 0.6875 8.93555 0.6875C4.55998 0.6875 0.998047 4.24943 0.998047 8.625ZM2.62305 8.625C2.62305 5.14788 5.4513 2.3125 8.93555 2.3125C12.4198 2.3125 15.248 5.14788 15.248 8.625C15.248 12.1021 12.4198 14.9375 8.93555 14.9375C5.4513 14.9375 2.62305 12.1021 2.62305 8.625Z",
    fill: "#393939",
    stroke: "#393939",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2363 17.0744C16.3982 17.2362 16.6054 17.3126 16.8106 17.3126C17.0159 17.3126 17.223 17.2362 17.3849 17.0744C17.7 16.7592 17.7 16.2409 17.3849 15.9258L15.8849 14.4258C15.5698 14.1107 15.0515 14.1107 14.7363 14.4258C14.4212 14.7409 14.4212 15.2592 14.7363 15.5744L16.2363 17.0744Z",
    fill: "#393939",
    stroke: "#393939",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ce47d2e17853331f01ca300d56053224.svg";
export { ForwardRef as ReactComponent };